import React from "react";

const FemaleIcon = ({ fill, ...restProps }) => {
  return (
    <svg
      viewBox="0 0 27 27"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M10.63 1.744a6.297 6.297 0 0 0-3.595 1.823A6.356 6.356 0 0 0 5.236 7.18c-.06.415-.06 1.353.002 1.76.213 1.409.825 2.634 1.806 3.616a6.25 6.25 0 0 0 2.482 1.539c.4.135.944.265 1.112.265.081 0 .082.013.082 1.977v1.977l-1.35.013c-1.293.012-1.357.017-1.51.099-.299.161-.461.423-.459.743.002.343.267.7.588.789.091.025.664.042 1.441.042h1.29v1.29c0 .777.017 1.35.042 1.441.089.321.446.586.789.588.32.002.582-.16.743-.459.082-.153.087-.217.099-1.51l.013-1.35h1.287c.819 0 1.345-.017 1.447-.045.219-.061.479-.327.54-.555a.83.83 0 0 0-.419-.958l-.199-.102-1.331-.012-1.331-.013v-1.977c0-1.965.001-1.978.082-1.978.366 0 1.357-.316 1.967-.627 1.241-.633 2.308-1.727 2.861-2.933.435-.949.608-1.727.609-2.74.002-1.839-.716-3.47-2.079-4.723a6.5 6.5 0 0 0-2.749-1.476c-.702-.177-1.758-.227-2.461-.117m1.41 1.617a4.738 4.738 0 0 1 3.761 2.634c.302.621.438 1.176.467 1.905.096 2.362-1.623 4.443-3.982 4.822-.384.062-1.17.052-1.577-.021-1.433-.254-2.742-1.24-3.4-2.561-.527-1.059-.615-2.435-.228-3.589.241-.72.573-1.25 1.137-1.814C9.26 3.693 10.602 3.21 12.04 3.361"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
};

export default FemaleIcon;
